import { ComponentProps } from 'react';
import clsx from 'clsx';
import Collapse from 'antd/es/collapse';

import './OpCollapse.scss';

interface OpCollapseProps
  extends Omit<ComponentProps<typeof Collapse>, 'children'> {
  testId?: string;
}

/**
 * OpCollapse is a wrapper around Ant Design's Collapse component.
 * It provides expandable/collapsible panels for organizing content that can be hidden or shown.
 * 
 * Use this component to save space and organize content into sections that users can expand on demand.
 * Useful for FAQs, detailed information, and content-heavy interfaces.
 * 
 * @example
 * <OpCollapse>
 *   <OpCollapse.Panel header="Section 1" key="1">
 *     Content for section 1
 *   </OpCollapse.Panel>
 * </OpCollapse>
 * 
 */
export const OpCollapse = ({
  className,
  testId = 'op-collapse',
  ...collapseProps
}: OpCollapseProps) => {
  return (
    <div className="op-collapse-container">
      <Collapse
        className={clsx('op-collapse', className)}
        data-testid={testId}
        {...collapseProps}
      />
    </div>
  );
};
